import React, { useState, useEffect } from "react";
import "react-table/react-table.css";
import Pagination from "../Pagination.js";
import Service from "../../../apiService";

function Row({ data, index }) {
  const dataArray = Object.values(data);
  return (
    <tr>
      <td>{index}</td>
      {dataArray.map((value, i) => {
        return <td key={i}>{value}</td>;
      })}
    </tr>
  );
}

const TableServerSidePagination = ({
  data = [],
  method = "post",
  columnMapper,
  headers,
  bodyRequest,
  url,
  isBordered = false,
  callback,
}) => {
  const [lists, setLists] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    data.current_page ? data.current_page : 1
  );
  const [from, setFrom] = useState(1);

  useEffect(() => {
    setLists(data.data);
    setCurrentPage(data.current_page ? data.current_page : 1);
    setFrom(1);
  }, [data]);

  const fetchPage = async (pageNumber) => {
    let response;
    if (method === "post")
      response = await Service.post(`${url}?page=${pageNumber}`, bodyRequest);
    else response = await Service.get(`${url}?page=${pageNumber}&${bodyRequest}`);
    return response;
  };

  const handlePageChange = async (pageNumber) => {
    const response = await fetchPage(pageNumber);
    if (response) {
      if (callback !== undefined) {
        callback(response.data);
      }
      setLists(response.data.data);
      setCurrentPage(response.data.current_page);
      setFrom(response.data.from);
    }
  };

  const filteredLists = lists ? lists.map(columnMapper) : [];

  return (
    <div>
      <div className='table-responsive'>
        <table
          className={`table align-items-center table-striped table-${
            isBordered ? "bordered" : "flush"
          } `}>
          <thead className='thead-light'>
            <tr>
              {headers.map((header, i) => {
                return (
                  <th key={i} scope='col' className='sort'>
                    {header}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className='list'>
            {filteredLists.length > 0 ? (
              filteredLists.map((filteredList, i) => {
                return <Row key={i} data={filteredList} index={from + i} />;
              })
            ) : (
              <tr>
                <td colSpan={headers.length} style={{ textAlign: "center" }}>
                  tidak ada data..
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {lists && (
          <Pagination
            listsPerPage={data.per_page}
            totalLists={data.total}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
  );
};

// export class TableServerSidePagination extends Component {
//   static defaultProps = {
//     data: { data: [] },
//     headers: ['No', 'Nama', 'Usia', 'Alamat']
//   };

//   state = {
//     lists: [],
//     currentPage: 1,
//     propsBlock: false,
//     error: '',
//     from: 1
//   };

//   static getDerivedStateFromProps(props, state) {
//     if (!state.propsBlock)
//       return { lists: props.data.data, error: props.error };
//     return null;
//   }

//   fetchPatients = async pageNumber => {
//     const response = await Service.post(
//       `${this.props.url}?page=${pageNumber}`,
//       this.props.bodyRequest
//     );
//     if (response.status !== 'success.') {
//       this.setState({
//         propsBlock: true,
//         error: response.statusText
//       });
//       return undefined;
//     }
//     return response;
//   };

//   handlePageChange = async pageNumber => {
//     this.setState({
//       propsBlock: true
//     });
//     const response = await this.fetchPatients(pageNumber);
//     response &&
//       this.setState({
//         lists: response.data.data,
//         currentPage: response.data.current_page,
//         from: response.data.from
//       });
//   };

//   render() {
//     const { currentPage, lists, error, from } = this.state;
//     const { mapper, headers, column, buttons } = this.props;
//     const filteredLists = this.state.lists
//       ? this.state.lists.map(mapper)
//       : null;

//     return (
//       <div>
//         <div className='table-responsive'>
//           <table className='table align-items-center table-flush'>
//             <thead className='thead-light'>
//               <tr>
//                 {headers.map((header, i) => {
//                   return (
//                     <th key={i} scope='col' className='sort'>
//                       {header}
//                     </th>
//                   );
//                 })}
//               </tr>
//             </thead>
//             <tbody className='list'>
//               {error !== '' && error !== undefined ? (
//                 <td style={{ textAlign: 'center' }} colSpan={headers.length}>
//                   {error}
//                 </td>
//               ) : filteredLists !== null ? (
//                 filteredLists.map((data, i) => {
//                   return (
//                     <Row
//                       key={data.id}
//                       data={data}
//                       buttons={buttons}
//                       index={from + i}
//                       lists={lists[i]}
//                       onClick={this.props.passToVisit}
//                     />
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan={headers.length} style={{ textAlign: 'center' }}>
//                     tidak ada data..
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//           {lists && (
//             <Pagination
//               listsPerPage={this.props.data.per_page}
//               totalLists={this.props.data.total}
//               handlePageChange={this.handlePageChange}
//               currentPage={currentPage}
//             />
//           )}
//         </div>
//       </div>
//     );
//   }
// }

export default TableServerSidePagination;
